/*
 * @Author: your name
 * @Date: 2021-01-05 20:41:36
 * @LastEditTime: 2021-03-25 21:57:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \1223\xbase_extension_zbzt_live_sdk\src\channel\sdk-cb.js
 */
import NOTICE from '../notice';
import dict from '../util/dict';

const sdkCb = {
  join(data) {
    NOTICE.join({
      userId: data.userid || data.actorId,
      userName: data.actorName,
      role: data.actorType || data.role
    });
  },
  joinAck(data) {
    NOTICE.joinAck({
      userId: data.userid || data.actorId,
      userName: data.actorName,
      role: data.actorType || data.role
    });
  },
  addStream(data) {
    NOTICE.addStream({
      userId: data.userid || data.actorId,
      userName: data.actorName,
      role: data.actorType || data.role,
      streamId: data.streamUrl,
      videoSrc: ''
    });
  },
  removeStream(data) {
    NOTICE.removeStream({
      userId: data.userid || data.actorId|| data.streamUrl.split('_')[2],
      userName: data.actorName,
      role: data.actorType || data.role,
      streamId: data.streamUrl
    });
  },
  updateStreamDeviceStatus(data) {
    NOTICE.updateStreamDeviceStatus({
      userId: data.userid || data.actorId,
      userName: data.actorName,
      role: data.actorType || data.role,
      //获取设备类型和状态对应的文案，返回给业务层
      deviceType: dict.devicesMap.get(parseInt(data.streamType)),
      deviceStatus: dict.devicesStatusMap.get(parseInt(data.status))
    });
  },
  leave(data) {
    NOTICE.leave({
      userId: data.userid || data.actorId,
      userName: data.actorName,
      role: data.actorType || data.role
    });
  },
  channelDisconnect() {
    NOTICE.channelDisconnect();
  },
  userDisconnect(data) {
    NOTICE.userDisconnect({
      userId: data.userid || data.actorId,
      userName: data.username,
      role: data.role
    });
  }
};

export default sdkCb;
